export { default } from './VideoWithTitle';
